export default function StoryIcon ({ url }) {
  return (
    <div className='flex my-4'>
      <div className='flex-3' />
      <div className='flex-1'>
        <img src={url} />
      </div>
      <div className='flex-3' />
    </div>
  )
}
